module.exports = __webpack_public_path__ + "img/member-zmc.5d95c5da.jpg";